import VuePapaParse from "vue-papa-parse";

export default {
    install(app) {
        app.use(VuePapaParse);

        app.provide('$papa', app.config.globalProperties.$papa);
    }
}
